const platform = window.fe.project
export default {
  fontConfigStructure: {
    url: `/${platform}/rule/execute/stringValue?key=font_config_structure`,
    type: 'get'
  },
  isEnableFontConfig: {
    url: `/${platform}/rule/execute/stringValue?key=is_enable_font_config`,
    type: 'get'
  }

}
